// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__t8HDp","content":"LoadingAlert_content__2jjoL"};